import { useRef } from "react";
import { Toaster, toast } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Amenities } from "@/components/Amenities";
import { Location } from "@/components/Location";
import { ProjectPlan } from "@/components/ProjectPlan";
import { Gallery } from "@/components/Gallery";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { StickyBottomBar } from "@/components/StickyBottomBar";
import { UrgencyPopup } from "@/components/UrgencyPopup";

function App() {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleBrochure = () => {
    toast.info("Brochure coming soon", {
      description:
        "Our detailed brochure is being prepared. Book a site visit and we'll share it with you.",
    });
  };

  return (
    <div className="App pb-[108px]">
      <Toaster position="top-center" richColors />
      <Navbar onBookVisit={scrollToForm} />
      <Hero onBookVisit={scrollToForm} onBrochure={handleBrochure} />
      <About />
      <Amenities />
      <Location />
      <ProjectPlan />
      <Gallery />
      <LeadForm ref={formRef} />
      <Footer />
      <WhatsAppFloat />
      <StickyBottomBar onBookVisit={scrollToForm} />
      <UrgencyPopup onBookVisit={scrollToForm} />
    </div>
  );
}

export default App;
